<template>
   <div
    class="the-navbar__user-meta flex items-center"
  >
    <div class="text-right leading-tight hidden sm:block">
      <!-- <p class="font-semibold">{{ activeUserInfo }}</p>
       -->
    </div>

    <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer">
      <div class="con-img ml-4">
        <vs-chip>
          <div class="vx-row rounded-full">
            <vs-chip>
              <vs-avatar size="30px"/>
              <feather-icon icon="AlignJustifyIcon" svgClasses="w-4 h-4" />
            </vs-chip>
          </div>
        </vs-chip>
      </div>

      <vs-dropdown-menu class="vx-navbar-dropdown">
        <ul style="min-width: 9rem">
         
          <div v-if="user">
           <router-link to="/owner">
          
          <li v-if="this.user.role === 'OWNER'"
            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white" 
          >
            <feather-icon icon="CheckSquareIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">Espace Propriétaire</span>
          </li>
          </router-link>
           <router-link to="/wishlist">
           <li
            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white" 
          >
            <feather-icon icon="HeartIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">Liste des Souhaits</span>
          </li>
          </router-link>
          
      
          <vs-divider class="m-1" />
          <li
            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
            @click="logout" 
          >
            <feather-icon icon="LogOutIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">Logout</span>
          </li>
       </div>
            <router-link to="/login">
            <li
            class="flex py-2 px-3 cursor-pointer hover:bg-primary hover:text-white"
            v-if="!user"
          >
            <feather-icon icon="user" svgClasses="w-4 h-4" />
            <span class="ml-2">S'inscrire / Se connecter</span>
          </li>
          </router-link>
        </ul>
      </vs-dropdown-menu>
    </vs-dropdown>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import { logoutUser } from '@/helpers/utils'

export default {
  data () {
    return {
      loggedIn :null
    }
  },
  computed: {
    ...mapGetters({
      user:'user'
    })
   
  },
  watch:{
    user (val) {
      this.SET_USER(val)
    }
  },
  methods: {
    ...mapMutations(['SET_USER']),
    logout () {
      logoutUser()
      window.location.href = '/'
    }
  }
}
</script>
